/**
 * App layout
 * 
 */

import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

// Layout

import Layout from './layout/layout';
import Header from './layout/header/header';
import Footer from './layout/footer/footer';
import Drawer from './layout/drawer/drawer';
import Output from './layout/output/output';
import Content from './layout/content/content';
import Main from './layout/main/main';
import Elevator from './layout/elevator/elevator';
import Backdrop from './layout/backdrop/backdrop';
import Microdata from './layout/microdata/microdata';
import Analytics from './layout/analytics/analytics';

// Components

import Nav from '../components/nav/nav';

// Pages

import Home from './pages/home';
import Page from './pages/page';
import Showcase from './pages/showcase';
import NotFound from './pages/404';

const App = (props) => (
	
	<Layout>
		<Header settings={props.settings}>
			<Nav uid="nav-desktop" className="nav-desktop" nav={props.navigation}></Nav>
		</Header>
		<Content>
			
			<Main>
				<Switch>
					<Redirect exact from="/home" to="/" />
					<Route exact path="/" render={routeProps => <Home {...routeProps} cms={props.cms} settings={props.settings} device={props.device} />} />
					<Route exact path="/:uid" render={routeProps => <Page {...routeProps} cms={props.cms} settings={props.settings} device={props.device} />} />
					<Route exact path="/work/:uid" render={routeProps => <Showcase {...routeProps} cms={props.cms} settings={props.settings} device={props.device} />} />
		            <Route component={NotFound} />
		        </Switch>
			</Main>

			<Footer settings={props.settings}>
				<Nav uid="nav-footer-explore" className="nav-tree nav-footer" nav={props.navigation}>></Nav>
				<Nav uid="nav-footer-solutions" className="nav-tree nav-footer" nav={props.navigation}>></Nav>
				<Microdata render="company" settings={props.settings}></Microdata>
			</Footer>

			<Route component={Analytics} />

		</Content>
		<Drawer settings={props.settings}>
			<Nav uid="nav-footer-explore" className="nav nav-tree nav-drawer" nav={props.navigation}>></Nav>
			<Nav uid="nav-footer-solutions" className="nav nav-tree nav-drawer" nav={props.navigation}>></Nav>
		</Drawer>
		<Elevator></Elevator>
		<Output></Output>
		<Backdrop></Backdrop>
	</Layout>
);

export default App;



// WEBPACK FOOTER //
// ./src/containers/app.js